(() => {
  'use strict';
  const expectedTotals = [59900, 107820, 152745, 179700];
  const config = window.EnciaCalmReleasitCROConfig || {};
  const offers = Array.isArray(config.offers) ? config.offers : [];
  if (location.pathname !== '/products/enciacalm' || offers.length !== 4) return;

  const first = (root, selectors) => selectors.map((selector) => root.querySelector(selector)).find(Boolean);
  const eligible = (root) => {
    const cards = root ? [...root.querySelectorAll('._rsi-quantity-offers-offer')] : [];
    return cards.length === 4 && cards.every((card, index) => {
      const digits = (card.textContent || '').split('').filter((char) => char >= '0' && char <= '9').join('');
      return digits.includes(String(expectedTotals[index]));
    });
  };
  const setText = (root, selectors, value) => {
    const node = first(root, selectors);
    if (node && node.textContent !== value) node.textContent = value;
    return node;
  };
  const ensureDetail = (card, value) => {
    const info = first(card, ['._rsi-quantity-offers-info', '[class*="quantity-offers-info"]']);
    if (!info) return;
    let detail = info.querySelector('.ec-releasit-offer-detail');
    if (!value) { if (detail) detail.remove(); return; }
    if (!detail) { detail = document.createElement('div'); detail.className = 'ec-releasit-offer-detail'; info.append(detail); }
    if (detail.textContent !== value) detail.textContent = value;
  };
  const setImage = (card, value, index) => {
    const image = first(card, [
      'img._rsi-modal-line-item-image',
      '._rsi-modal-line-item-image-container img',
      'img[class*="modal-line-item-image"]'
    ]);
    if (!image || !value) return false;
    const absolute = (url) => new URL(url, location.href).href;
    if (absolute(image.getAttribute('src') || '') !== absolute(value)) image.src = value;
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    image.alt = `EncíaCalm: recibe ${index + 1} ${index ? 'unidades' : 'unidad'}`;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.dataset.ecOfficialQuantity = String(index + 1);
    return true;
  };
  const ensureIntro = (root) => {
    const heading = first(root, ['._rsi-custom-text-field', '._rsi-quantity-offers-main-title']);
    if (!heading) return;
    const headingCopy = 'ELIGE LA CANTIDAD QUE QUIERES RECIBIR';
    if (heading.textContent !== headingCopy) heading.textContent = headingCopy;
    heading.dataset.ecOfferHeading = 'true';
    let summary = root.querySelector('.ec-releasit-cro-summary');
    if (!summary) { summary = document.createElement('div'); summary.className = 'ec-releasit-cro-summary'; heading.after(summary); }
    const markup = '<strong>Ofertas de 1, 2, 3 o 4 sprays de EncíaCalm.</strong><span>pide hoy y paga cuando recibes</span>';
    if (summary.innerHTML !== markup) summary.innerHTML = markup;
  };
  const enhance = () => {
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (!eligible(root)) return false;
    root.dataset.ecEnhanced = 'true';
    root.dataset.ecEnhancer = 'v11';
    ensureIntro(root);
    [...root.querySelectorAll('._rsi-quantity-offers-offer')].forEach((card, index) => {
      const item = offers[index];
      card.dataset.ecOfferPosition = String(index);
      if (!item) return;
      const info = first(card, ['._rsi-quantity-offers-info', '[class*="quantity-offers-info"]']);
      const title = setText(card, ['._rsi-quantity-offers-title', '[class*="quantity-offers-title"]'], item.title);
      const plaque = setText(card, ['._rsi-quantity-offers-plaque', '[class*="quantity-offers-plaque"]'], item.plaque);
      if (plaque) plaque.dataset.ecOfferCopy = 'true';
      ensureDetail(card, item.detail);
      if (matchMedia('(max-width: 560px)').matches) {
        if (info) {
          info.style.setProperty('display', 'grid', 'important');
          info.style.setProperty('grid-template-columns', 'minmax(0, 1fr)', 'important');
          info.style.setProperty('justify-items', 'start', 'important');
          info.style.setProperty('align-items', 'start', 'important');
          info.style.setProperty('text-align', 'left', 'important');
        }
        [title, plaque].filter(Boolean).forEach((node) => {
          node.style.setProperty('justify-self', 'start', 'important');
          node.style.setProperty('align-self', 'flex-start', 'important');
          node.style.setProperty('margin-left', '0', 'important');
          node.style.setProperty('margin-right', '0', 'important');
          node.style.setProperty('transform', 'none', 'important');
          node.style.setProperty('position', 'static', 'important');
        });
        if (title) { title.style.setProperty('display', 'block', 'important'); title.style.setProperty('width', '100%', 'important'); title.style.setProperty('text-align', 'left', 'important'); }
        if (plaque) { plaque.style.setProperty('display', 'flex', 'important'); plaque.style.setProperty('width', 'fit-content', 'important'); }
      }
      setImage(card, item.image, index);
    });
    return true;
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  };
  const start = () => {
    schedule();
    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {childList: true, subtree: true});
    window.EnciaCalmReleasitCROV11 = { enhance, observer };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
